<template>
    <div id="Login">
        <div style="width: 100%; height: 30px;">
<!--            <div style="float: right; height: 100%; width: 30px; background: white">-->

<!--            </div>-->
        </div>
        <div style="height: 150px; text-align: center">
            <van-image :src="require('@/assets/image/common/logonew.png')" width="150px" height="150px" style="margin-top: 30px;"></van-image>
        </div>
        <div style="height: 100px; text-align: center">
        </div>
        <van-form @submit="onSubmit">
            <van-field
                    v-model="loginForm.username"
                    :name="langText.userName"
                    :label="langText.userName"
                    :placeholder="langText.userName"
                    :rules="[{ required: true, message: langText.userNameMessage }]"
            />
            <van-field
                    type="password"
                    v-model="loginForm.password"
                    :name="langText.password"
                    :label="langText.password"
                    :placeholder="langText.password"
                    :rules="[{ required: true, message: langText.passwordMessage }]"
            />

            <van-cell is-link :title = "langText.title"  @click="show = true" />
            <van-action-sheet
                    v-model="show"
                    :actions="actions"
                    close-on-click-action
                    cancel-text="取消"
                    @cancel="onCancel"
                    @select="onSelect"
            />
            <div style="padding:10px 16px">
                <span @click="toRegister" style="color: #999999">
                    {{langText.register}}
                </span>
<!--                <span @click="loginNumber" style="float: right; color: #999999">-->
<!--                    手机号码登录-->
<!--                </span>-->
<!--                <br/>-->
<!--                <br/>-->
                <span @click="toForgetPassword" style="float: right; color: #999999">
                    {{langText.forgetPassword}}
                </span>
            </div>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                   {{langText.login}}
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>

    import { Form, Field, Button, Image, Toast, ActionSheet,Cell } from 'vant';
    import { wxLogin } from "@/network/login/login";
    import { setLang } from "@/network/mine/mine";
    import { langPackage } from "@/config/lang/loginLang";
    export default {
        name: "Login",
        components: {
            [ Form.name ]: Form,
            [ Field.name ]: Field,
            [ Button.name ]: Button,
            [ Image.name ]: Image,
            [ ActionSheet.name ]: ActionSheet,
            [ Cell.name ]: Cell,
        },
        data() {
            return{
                loginForm: {
                  username: '',
                  password: ''
                },
                lang:"cn",
                langText:{},
                show:false,
                // titleLabel:"Please select a language type (Default: Chinese)",
                actions: [
                    { name: '中文' },
                    { name: 'English' },
                    ],
            }
        },
        methods: {
            onSelect(item) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                //选择语言的时候 执行刷新页面 防止缓存
                this.show = false;
                if (item.name == "中文"){
                    this.$router.push({path: '/index/login', query: {lang: "cn"}});
                    location.reload();
                }

                if (item.name == "English"){
                    this.$router.push({path: '/index/login', query: {lang: "en"}});
                    location.reload();
                }
            },
            onCancel() {
                Toast('取消');
            },
            onSubmit() {
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
                setTimeout(() => {
                    this.$store.dispatch('Login', this.loginForm).then(() => {
                        Toast.clear();
                        setLang(this.lang)
                        this.$router.push({path: '/'})
                    }).catch(err => {
                        Toast.clear();
                        Toast('登录出错')
                    })
                }, 1000)
            },
            //跳转到注册
            toRegister(){
                this.$router.push({path:'/index/register', query: {lang: this.lang}})
            },
            loginNumber() {
                this.$router.push('/index/loginPhone')
            },
            toForgetPassword() {

                this.$router.push({path:'/index/forgetPassword', query:{lang: this.lang}})
            },
            isWeiXin() {
                //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                    return 4;
                } else{
                    return 2;
                }
            },
            getCode () { // 非静默授权，第一次有弹框
                const code = this.getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
              console.log(code)
                const local = 'https://www.agougoubuy.cn/index/login';
                const appid = "wxa4b77289f13478de";
                //重定向到 微信授权服务里
                if (code == null || code === '') {
                    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri=' + local + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
                } else {
                    //如果有code 则直接登录
                    this.$store.dispatch('wxLogin', code).then(() => {
                        this.$router.push({path: '/'})
                    }).catch(err => {
                        Toast(err)
                    })
                }
            },
            getUrlParam: function (name) {
                var reg= new RegExp('(^|&)'+name+'=([^&]*)(&|$)')
                var r = window.location.search.substr(1).match(reg);
                if(r!=null) return unescape(r[2])
                return null
            },
            getLangText(){
                if(this.$route.query.lang != "" && this.$route.query.lang != undefined){
                    this.lang = this.$route.query.lang;
                }
                if (this.lang == "cn"){
                    this.langText = langPackage.cn;
                }
                if (this.lang == "en"){
                    this.langText = langPackage.en;
                }
                //
            }
        },
        created() {
            if(this.isWeiXin()==4){
                this.getCode();
            }
            this.getLangText()
        }
    }

</script>

<style scoped>
    @import "~@/assets/css/index/login.css";
    body, html{
        background: white;
    }
</style>
